"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-right"
  }, [_c("div", {
    staticClass: "content-box-top"
  }, [_c("div", {
    staticClass: "item-box"
  }, [_c("div", {
    staticClass: "energy-box-top"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" "), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.nhsj")))])]), _vm._v(" "), _c("div", {
    staticClass: "transition-line"
  }), _vm._v(" "), _c("div", {
    staticClass: "energy-content"
  }, [_c("div", {
    staticClass: "energy-data-box-big ssnx"
  }, [_vm._m(0), _vm._v(" "), _c("div", {
    staticClass: "ssnx-text"
  }, [_c("span", {
    staticClass: "ssnx-text-num"
  }, [_vm._v(_vm._s(this.headerData.scop))]), _vm._v(" "), _c("span", {
    staticClass: "ssnx-text-span"
  }, [_vm._v(_vm._s(_vm.$t("home_page.ssnx")))])])]), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("div", {
    staticClass: "box-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/dayHd.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "rhdl-num"
  }, [_vm._v(_vm._s(this.headerData.dayElect))]), _vm._v(" "), _c("span", {
    staticClass: "rhdl-title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.rhdl")))]), _vm._v(" "), _c("span", {
    staticClass: "rhdl-unit"
  }, [_vm._v("kWh")])])]), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("div", {
    staticClass: "box-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/dayNx.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "rnx-num"
  }, [_vm._v(_vm._s(this.headerData.dayCop))]), _vm._v(" "), _c("span", {
    staticClass: "rnx-title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.rnx")))])])]), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("div", {
    staticClass: "box-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/dayGl.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "rgll-num"
  }, [_vm._v(_vm._s(this.headerData.dayCool))]), _vm._v(" "), _c("span", {
    staticClass: "rgll-title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.rgll")))]), _vm._v(" "), _c("span", {
    staticClass: "rgll-unit"
  }, [_vm._v("kWh")])])]), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("div", {
    staticClass: "box-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/lqswd.png"),
      alt: ""
    }
  }), _vm._v(" "), _c("span", {
    staticClass: "lqswd-num"
  }, [_vm._v(_vm._s(this.headerData.temperatureDifference))]), _vm._v(" "), _c("span", {
    staticClass: "lqswd-title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.ldswd")))]), _vm._v(" "), _c("span", {
    staticClass: "lqswd-unit"
  }, [_vm._v("℃")])])])])]), _vm._v(" "), _c("div", {
    staticClass: "item-box border-box"
  }, [_c("img", {
    staticClass: "image-info",
    attrs: {
      src: _vm.projectInfo.projectPicture,
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticClass: "item-box"
  }, [_c("div", {
    staticClass: "energy-box-top"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" "), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.nxsj")))])]), _vm._v(" "), _c("div", {
    staticClass: "transition-line"
  }), _vm._v(" "), _c("div", {
    staticClass: "energy-content"
  }, [_c("div", {
    staticClass: "energy-data-box-big"
  }, [_c("eedata", {
    attrs: {
      chartData: _vm.homeData[2],
      timeType: "日"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box-big"
  }, [_c("eedata", {
    attrs: {
      chartData: _vm.homeData[2],
      timeType: "月"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box-big"
  }, [_c("eedata", {
    attrs: {
      chartData: _vm.homeData[2],
      timeType: "年"
    }
  })], 1)])])]), _vm._v(" "), _c("div", {
    staticClass: "content-box-bottom"
  }, [_c("div", {
    staticClass: "item-box"
  }, [_c("div", {
    staticClass: "energy-box-top"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" "), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.sbcs")))])]), _vm._v(" "), _c("div", {
    staticClass: "transition-line"
  }), _vm._v(" "), _c("div", {
    staticClass: "energy-content"
  }, [_c("div", {
    staticClass: "energy-data-box"
  }, [_c("poa", {
    attrs: {
      "poa-data": this.sbcsData1,
      type: "sbcsData1"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("poa", {
    attrs: {
      "poa-data": this.sbcsData2,
      type: "sbcsData2"
    }
  }, [_vm._v(">")])], 1), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("poa", {
    attrs: {
      "poa-data": this.sbcsData3,
      type: "sbcsData3"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "energy-data-box"
  }, [_c("poa", {
    attrs: {
      "poa-data": this.sbcsData4,
      type: "sbcsData4"
    }
  })], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "item-box border-box"
  }, [_c("div", {
    staticClass: "energy-box-top"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" "), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.jnl")))])]), _vm._v(" "), _c("div", {
    staticClass: "transition-line"
  }), _vm._v(" "), _c("esaved")], 1), _vm._v(" "), _c("div", {
    staticClass: "item-box"
  }, [_c("div", {
    staticClass: "energy-box-top"
  }, [_c("span", {
    staticClass: "dot"
  }), _vm._v(" "), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("home_page.nhzb")))])]), _vm._v(" "), _c("div", {
    staticClass: "transition-line"
  }), _vm._v(" "), _c("div", {
    staticClass: "energy-nhzb"
  }, [_c("ecRatio", {
    attrs: {
      "pie-data": _vm.homeData[5]
    }
  })], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ssnx-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/ssnx.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;